import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=ccb565c4&scoped=true"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js"
import style0 from "./LoadingAnimation.vue?vue&type=style&index=0&id=ccb565c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb565c4",
  null
  
)

export default component.exports